<template>
	<v-container fluid>
		<v-card class="rounded-xl" elevation="0" outlined>
			<v-card-title class="text-h5 font-weight-bold">
				Your Orders
			</v-card-title>
			<v-card-text v-if="orders.length < 1" class="text-center py-8">
				<i class="fas fa-spider grey--text" style="font-size: 48px"></i>
				<h3 class="grey--text mt-4">Nothing to See</h3>
			</v-card-text>
			<v-card-text class="pt-0">
				<v-text-field
					rounded
					outlined
					dense
					hide-details
					label="Search by product title"
					v-model="orderSearch"
					clearable
					class="mb-4"></v-text-field>
				<v-card class="rounded-xl" elevation="0" outlined>
					<v-tabs v-model="tab" background-color="transparent">
						<v-tabs-slider color="primary"></v-tabs-slider>
						<v-tab>Regular ({{ regularOrders.length }})</v-tab>
						<v-tab>Preorder ({{ preorders.length }})</v-tab>
						<v-tab>On Hold ({{ otherOrders.length }})</v-tab>
						<v-tab>No Invoice ({{ noInvoiceOrders.length }})</v-tab>
					</v-tabs>
					<v-divider></v-divider>
					<v-tabs-items v-model="tab" touchless>
						<v-tab-item>
							<div
								class="pa-3"
								style="
									display: flex;
									flex-direction: column;
									gap: 8px;
								">
								<v-card
									v-for="(order, idx) in regularOrders"
									:key="`order-${order.id}`"
									class="d-flex"
									elevation="0"
									style="gap: 10px">
									<order-card
										:order="order"
										@handle-event="openDialog"></order-card>
									<order-options
										class="d-none d-sm-none d-md-none d-lg-block"
										v-model="regularOrders[idx]"
										@delete-event="
											refilterOrders
										"></order-options>
								</v-card>
							</div>
						</v-tab-item>
						<v-tab-item>
							<div
								class="pa-3"
								style="
									display: flex;
									flex-direction: column;
									gap: 8px;
								">
								<v-card
									v-for="(order, idx) in preorders"
									:key="`order-${order.id}`"
									class="d-flex"
									elevation="0"
									style="gap: 10px">
									<order-card
										:order="order"
										@handle-event="openDialog"></order-card>
									<order-options
										class="d-none d-sm-none d-md-none d-lg-block"
										v-model="preorders[idx]"
										@delete-event="
											refilterOrders
										"></order-options>
								</v-card>
							</div>
						</v-tab-item>
						<v-tab-item>
							<div
								class="pa-3"
								style="
									display: flex;
									flex-direction: column;
									gap: 8px;
								">
								<v-card
									v-for="(order, idx) in otherOrders"
									:key="`order-${order.id}`"
									class="d-flex"
									elevation="0"
									style="gap: 10px">
									<order-card
										:order="order"
										@handle-event="openDialog"></order-card>
									<order-options
										class="d-none d-sm-none d-md-none d-lg-block"
										v-model="
											otherOrders[idx]
										"></order-options>
								</v-card>
							</div>
						</v-tab-item>
						<v-tab-item>
							<div
								class="pa-3"
								style="
									display: flex;
									flex-direction: column;
									gap: 8px;
								">
								<v-card
									v-for="(order, idx) in noInvoiceOrders"
									:key="`order-${order.id}`"
									class="d-flex"
									elevation="0"
									style="gap: 10px">
									<order-card
										:order="order"
										@handle-event="openDialog"></order-card>
									<order-options
										class="d-none d-sm-none d-md-none d-lg-block"
										v-model="
											noInvoiceOrders[idx]
										"></order-options>
								</v-card>
							</div>
						</v-tab-item>
					</v-tabs-items>
				</v-card>
			</v-card-text>
		</v-card>
		<v-dialog v-model="dialog" max-width="350">
			<order-options
				show-id
				v-model="selectedOrder"
				@delete-event="refilterOrders"></order-options>
		</v-dialog>
	</v-container>
</template>
<script>
import backendService from "@/services/backend-service.js";
import generalMixin from "@/js/general-mixin";
import OrderCard from "@/components/OrderCard.vue";
import OrderOptions from "@/components/OrderOptions.vue";
import { OrderType } from "@/js/enum";
export default {
	name: "OrderList",
	mixins: [generalMixin],
	components: { "order-card": OrderCard, "order-options": OrderOptions },
	data() {
		return {
			orders: [],
			selectedOrder: null,
			dialog: false,
		};
	},
	created: function () {
		this.getOrders();
	},
	beforeRouteLeave(to, from, next) {
		this.$store.commit(
			"interactStore/setOrderListScrollPosition",
			window.scrollY,
		);
		next();
	},
	watch: {
		orders: function (newVal) {
			if (newVal && newVal.length > 0) {
				this.$nextTick(() => {
					const savedPosition =
						this.$store.getters[
							"interactStore/orderListScrollPosition"
						];
					if (savedPosition > 0) {
						window.scrollTo(0, savedPosition);
					}
				});
			}
		},
	},
	computed: {
		Regular() {
			return this.getIdByEnum(OrderType.Regular);
		},
		PlaceHolder() {
			return this.getIdByEnum(OrderType.PlaceHolder);
		},
		Stale() {
			return this.getIdByEnum(OrderType.Stale);
		},
		Preorder() {
			return this.getIdByEnum(OrderType.Preorder);
		},
		filteredOrders() {
			let orders = this.orders;
			let searchStr = this.orderSearch;
			searchStr = searchStr ? searchStr.trim().toLowerCase() : "";
			if (searchStr && searchStr.length) {
				orders = orders.filter((e) => {
					let orderDetails = e.orderDetails;
					for (let i = 0; i < orderDetails.length; i++) {
						let str = orderDetails[i].productTitle;
						if (
							str
								.toString()
								.trim()
								.toLowerCase()
								.includes(searchStr)
						)
							return true;
					}
					return false;
				});
			}

			return orders;
		},
		regularOrders() {
			return this.filteredOrders.filter((e) => e.typeId == this.Regular);
		},
		preorders() {
			return this.filteredOrders.filter((e) => e.typeId == this.Preorder);
		},
		otherOrders() {
			return this.filteredOrders.filter(
				(e) => e.typeId != this.Regular && e.typeId != this.Preorder,
			);
		},
		noInvoiceOrders() {
			return this.filteredOrders.filter(
				(e) =>
					(e.typeId == this.Regular ||
						e.typeId == this.PlaceHolder) &&
					!e.invoiceId,
			);
		},
		orderSearch: {
			get() {
				return this.$store.getters["orderSearch"];
			},
			set(val) {
				return this.$store.commit("setOrderSearch", val);
			},
		},
		tab: {
			get() {
				return this.$store.getters["interactStore/orderListTab"];
			},
			set(val) {
				this.$store.commit("interactStore/setOrderListTab", val);
			},
		},
	},
	methods: {
		getDataText(order) {
			return `${order.id}`;
		},

		getOrders() {
			backendService.getOrders().then((response) => {
				this.orders = response.data;
			});
		},
		openDialog(order) {
			this.selectedOrder = order;
			this.dialog = true;
		},
		refilterOrders(id) {
			this.orders = this.orders.filter((e) => e.id != id);
			this.selectedOrder = {};
			this.dialog = false;
		},
	},
};
</script>
<style scoped></style>
